// =============================================================================
// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// =============================================================================
// Generated by: npx tsx scripts/generate-icon-registry.ts
// Generated at: 2026-03-17T20:54:26.867Z
// Total icons: 231
// =============================================================================

import type { Icon } from "@tabler/icons-react";
import {
  IconAdjustments,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconApi,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowLeftRight,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsExchange,
  IconArrowsHorizontal,
  IconArrowsLeftRight,
  IconArrowsRightLeft,
  IconArrowsSort,
  IconAtom,
  IconAward,
  IconBatteryCharging,
  IconBell,
  IconBike,
  IconBolt,
  IconBrandAws,
  IconBrandAzure,
  IconBrandGoogleDrive,
  IconBrandSlack,
  IconBriefcase,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCommunity,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconBulb,
  IconBus,
  IconCalculator,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarClock,
  IconCalendarDot,
  IconCalendarEvent,
  IconCalendarMinus,
  IconCalendarMonth,
  IconCalendarRepeat,
  IconCalendarStats,
  IconCalendarTime,
  IconCalendarWeek,
  IconCamera,
  IconCameraRotate,
  IconCar,
  IconCarGarage,
  IconCarOff,
  IconCash,
  IconCashBanknote,
  IconChartBar,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconChecklist,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconCircle,
  IconCircleCheck,
  IconCirclePlus,
  IconCircleX,
  IconClick,
  IconClipboardCheck,
  IconClock,
  IconClockPlus,
  IconCloud,
  IconCloudDownload,
  IconCloudFog,
  IconCloudRain,
  IconCloudSnow,
  IconCloudStorm,
  IconCloudUpload,
  IconCoins,
  IconCopy,
  IconCreditCard,
  IconCrown,
  IconCurrencyDollar,
  IconCurrentLocation,
  IconDashboard,
  IconDatabase,
  IconDeviceMobile,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconDroplet,
  IconEdit,
  IconEngine,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileSpreadsheet,
  IconFileText,
  IconFileUpload,
  IconFileX,
  IconFiles,
  IconFilter,
  IconFirstAidKit,
  IconFlag,
  IconFlame,
  IconFocusCentered,
  IconFolder,
  IconFolderOpen,
  IconForms,
  IconGasStation,
  IconGauge,
  IconGlassFull,
  IconGlobe,
  IconGripHorizontal,
  IconHammer,
  IconHash,
  IconHeart,
  IconHeartRateMonitor,
  IconHelp,
  IconHelpCircle,
  IconHistory,
  IconHome,
  IconHourglass,
  IconInfoCircle,
  IconKey,
  IconLeaf,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconLoader,
  IconLock,
  IconLogout,
  IconMail,
  IconMap,
  IconMapOff,
  IconMapPin,
  IconMapPin2,
  IconMapPinCog,
  IconMapPinFilled,
  IconMapPinOff,
  IconMapPinPlus,
  IconMaximize,
  IconMenu,
  IconMessage,
  IconMinimize,
  IconMinus,
  IconMoon,
  IconMotorbike,
  IconMountain,
  IconNote,
  IconNotebook,
  IconNotes,
  IconPackage,
  IconPackages,
  IconPalette,
  IconPaperclip,
  IconParking,
  IconParkingCircle,
  IconParkingOff,
  IconPencil,
  IconPercentage,
  IconPhone,
  IconPhoto,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlus,
  IconPrinter,
  IconQuestionMark,
  IconRadio,
  IconReceipt,
  IconRefresh,
  IconRepeat,
  IconReportMoney,
  IconRoad,
  IconRocket,
  IconRotate,
  IconRotateClockwise,
  IconRotateClockwise2,
  IconRoute,
  IconSearch,
  IconSelector,
  IconSend,
  IconSettings,
  IconShield,
  IconShieldCheck,
  IconShieldExclamation,
  IconShirt,
  IconShoppingCart,
  IconSignature,
  IconSnowflake,
  IconSortAscending,
  IconSortDescending,
  IconSquareCheck,
  IconSteeringWheel,
  IconSticker,
  IconSun,
  IconTag,
  IconTarget,
  IconTemperature,
  IconThumbDown,
  IconThumbUp,
  IconToggleLeft,
  IconTool,
  IconTransferOut,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconTruck,
  IconUpload,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserEdit,
  IconUserMinus,
  IconUserPlus,
  IconUserX,
  IconUsers,
  IconWallet,
  IconWebhook,
  IconWheel,
  IconWifi,
  IconWind,
  IconWorld,
  IconX,
  IconZoomIn,
  IconZoomOut
} from "@tabler/icons-react";

/**
 * Registry of icons used in the application.
 *
 * This includes:
 * - Icons detected by scanning <AppIcon iconName="..." /> in source code
 * - Icons manually specified in scripts/icons.config.ts
 *
 * To add new icons:
 * 1. Use them in code with <AppIcon iconName="CirclePlus" /> where "CirclePlus" is an example name of a new icon
 * 2. Or add to manualIcons in scripts/icons.config.ts
 * 3. Run: npm run icons
 */
export const IconRegistry: Record<string, Icon> = {
  "Adjustments": IconAdjustments,
  "AlertCircle": IconAlertCircle,
  "AlertOctagon": IconAlertOctagon,
  "AlertTriangle": IconAlertTriangle,
  "Api": IconApi,
  "ArrowDown": IconArrowDown,
  "ArrowDownRight": IconArrowDownRight,
  "ArrowLeft": IconArrowLeft,
  "ArrowLeftRight": IconArrowLeftRight,
  "ArrowRight": IconArrowRight,
  "ArrowUp": IconArrowUp,
  "ArrowUpRight": IconArrowUpRight,
  "ArrowsExchange": IconArrowsExchange,
  "ArrowsHorizontal": IconArrowsHorizontal,
  "ArrowsLeftRight": IconArrowsLeftRight,
  "ArrowsRightLeft": IconArrowsRightLeft,
  "ArrowsSort": IconArrowsSort,
  "Atom": IconAtom,
  "Award": IconAward,
  "BatteryCharging": IconBatteryCharging,
  "Bell": IconBell,
  "Bike": IconBike,
  "Bolt": IconBolt,
  "BrandAws": IconBrandAws,
  "BrandAzure": IconBrandAzure,
  "BrandGoogleDrive": IconBrandGoogleDrive,
  "BrandSlack": IconBrandSlack,
  "Briefcase": IconBriefcase,
  "Building": IconBuilding,
  "BuildingBank": IconBuildingBank,
  "BuildingCommunity": IconBuildingCommunity,
  "BuildingSkyscraper": IconBuildingSkyscraper,
  "BuildingStore": IconBuildingStore,
  "BuildingWarehouse": IconBuildingWarehouse,
  "Bulb": IconBulb,
  "Bus": IconBus,
  "Calculator": IconCalculator,
  "Calendar": IconCalendar,
  "CalendarCheck": IconCalendarCheck,
  "CalendarClock": IconCalendarClock,
  "CalendarDot": IconCalendarDot,
  "CalendarEvent": IconCalendarEvent,
  "CalendarMinus": IconCalendarMinus,
  "CalendarMonth": IconCalendarMonth,
  "CalendarRepeat": IconCalendarRepeat,
  "CalendarStats": IconCalendarStats,
  "CalendarTime": IconCalendarTime,
  "CalendarWeek": IconCalendarWeek,
  "Camera": IconCamera,
  "CameraRotate": IconCameraRotate,
  "Car": IconCar,
  "CarGarage": IconCarGarage,
  "CarOff": IconCarOff,
  "Cash": IconCash,
  "CashBanknote": IconCashBanknote,
  "ChartBar": IconChartBar,
  "ChartLine": IconChartLine,
  "ChartPie": IconChartPie,
  "Check": IconCheck,
  "Checklist": IconChecklist,
  "Checks": IconChecks,
  "ChevronDown": IconChevronDown,
  "ChevronLeft": IconChevronLeft,
  "ChevronRight": IconChevronRight,
  "ChevronUp": IconChevronUp,
  "ChevronsLeft": IconChevronsLeft,
  "Circle": IconCircle,
  "CircleCheck": IconCircleCheck,
  "CirclePlus": IconCirclePlus,
  "CircleX": IconCircleX,
  "Click": IconClick,
  "ClipboardCheck": IconClipboardCheck,
  "Clock": IconClock,
  "ClockPlus": IconClockPlus,
  "Cloud": IconCloud,
  "CloudDownload": IconCloudDownload,
  "CloudFog": IconCloudFog,
  "CloudRain": IconCloudRain,
  "CloudSnow": IconCloudSnow,
  "CloudStorm": IconCloudStorm,
  "CloudUpload": IconCloudUpload,
  "Coins": IconCoins,
  "Copy": IconCopy,
  "CreditCard": IconCreditCard,
  "Crown": IconCrown,
  "CurrencyDollar": IconCurrencyDollar,
  "CurrentLocation": IconCurrentLocation,
  "Dashboard": IconDashboard,
  "Database": IconDatabase,
  "DeviceMobile": IconDeviceMobile,
  "Dots": IconDots,
  "DotsVertical": IconDotsVertical,
  "Download": IconDownload,
  "Droplet": IconDroplet,
  "Edit": IconEdit,
  "Engine": IconEngine,
  "ExternalLink": IconExternalLink,
  "Eye": IconEye,
  "EyeOff": IconEyeOff,
  "File": IconFile,
  "FileSpreadsheet": IconFileSpreadsheet,
  "FileText": IconFileText,
  "FileUpload": IconFileUpload,
  "FileX": IconFileX,
  "Files": IconFiles,
  "Filter": IconFilter,
  "FirstAidKit": IconFirstAidKit,
  "Flag": IconFlag,
  "Flame": IconFlame,
  "FocusCentered": IconFocusCentered,
  "Folder": IconFolder,
  "FolderOpen": IconFolderOpen,
  "Forms": IconForms,
  "GasStation": IconGasStation,
  "Gauge": IconGauge,
  "GlassFull": IconGlassFull,
  "Globe": IconGlobe,
  "GripHorizontal": IconGripHorizontal,
  "Hammer": IconHammer,
  "Hash": IconHash,
  "Heart": IconHeart,
  "HeartRateMonitor": IconHeartRateMonitor,
  "Help": IconHelp,
  "HelpCircle": IconHelpCircle,
  "History": IconHistory,
  "Home": IconHome,
  "Hourglass": IconHourglass,
  "InfoCircle": IconInfoCircle,
  "Key": IconKey,
  "Leaf": IconLeaf,
  "Link": IconLink,
  "List": IconList,
  "ListCheck": IconListCheck,
  "ListDetails": IconListDetails,
  "Loader": IconLoader,
  "Lock": IconLock,
  "Logout": IconLogout,
  "Mail": IconMail,
  "Map": IconMap,
  "MapOff": IconMapOff,
  "MapPin": IconMapPin,
  "MapPin2": IconMapPin2,
  "MapPinCog": IconMapPinCog,
  "MapPinFilled": IconMapPinFilled,
  "MapPinOff": IconMapPinOff,
  "MapPinPlus": IconMapPinPlus,
  "Maximize": IconMaximize,
  "Menu": IconMenu,
  "Message": IconMessage,
  "Minimize": IconMinimize,
  "Minus": IconMinus,
  "Moon": IconMoon,
  "Motorbike": IconMotorbike,
  "Mountain": IconMountain,
  "Note": IconNote,
  "Notebook": IconNotebook,
  "Notes": IconNotes,
  "Package": IconPackage,
  "Packages": IconPackages,
  "Palette": IconPalette,
  "Paperclip": IconPaperclip,
  "Parking": IconParking,
  "ParkingCircle": IconParkingCircle,
  "ParkingOff": IconParkingOff,
  "Pencil": IconPencil,
  "Percentage": IconPercentage,
  "Phone": IconPhone,
  "Photo": IconPhoto,
  "PlayerPause": IconPlayerPause,
  "PlayerPlay": IconPlayerPlay,
  "Plus": IconPlus,
  "Printer": IconPrinter,
  "QuestionMark": IconQuestionMark,
  "Radio": IconRadio,
  "Receipt": IconReceipt,
  "Refresh": IconRefresh,
  "Repeat": IconRepeat,
  "ReportMoney": IconReportMoney,
  "Road": IconRoad,
  "Rocket": IconRocket,
  "Rotate": IconRotate,
  "RotateClockwise": IconRotateClockwise,
  "RotateClockwise2": IconRotateClockwise2,
  "Route": IconRoute,
  "Search": IconSearch,
  "Selector": IconSelector,
  "Send": IconSend,
  "Settings": IconSettings,
  "Shield": IconShield,
  "ShieldCheck": IconShieldCheck,
  "ShieldExclamation": IconShieldExclamation,
  "Shirt": IconShirt,
  "ShoppingCart": IconShoppingCart,
  "Signature": IconSignature,
  "Snowflake": IconSnowflake,
  "SortAscending": IconSortAscending,
  "SortDescending": IconSortDescending,
  "SquareCheck": IconSquareCheck,
  "SteeringWheel": IconSteeringWheel,
  "Sticker": IconSticker,
  "Sun": IconSun,
  "Tag": IconTag,
  "Target": IconTarget,
  "Temperature": IconTemperature,
  "ThumbDown": IconThumbDown,
  "ThumbUp": IconThumbUp,
  "ToggleLeft": IconToggleLeft,
  "Tool": IconTool,
  "TransferOut": IconTransferOut,
  "Trash": IconTrash,
  "TrendingDown": IconTrendingDown,
  "TrendingUp": IconTrendingUp,
  "Truck": IconTruck,
  "Upload": IconUpload,
  "User": IconUser,
  "UserCheck": IconUserCheck,
  "UserCircle": IconUserCircle,
  "UserEdit": IconUserEdit,
  "UserMinus": IconUserMinus,
  "UserPlus": IconUserPlus,
  "UserX": IconUserX,
  "Users": IconUsers,
  "Wallet": IconWallet,
  "Webhook": IconWebhook,
  "Wheel": IconWheel,
  "Wifi": IconWifi,
  "Wind": IconWind,
  "World": IconWorld,
  "X": IconX,
  "ZoomIn": IconZoomIn,
  "ZoomOut": IconZoomOut,
};

/**
 * Fallback icon shown when requested icon doesn't exist
 */
export const FallbackIcon = IconQuestionMark;

/**
 * Check if an icon exists in the registry
 */
export function hasIcon(name: string): boolean {
  return name in IconRegistry;
}

/**
 * Get an icon from the registry (with fallback)
 */
export function getIcon(name: string): Icon {
  return IconRegistry[name] || FallbackIcon;
}

/**
 * List of all available icon names
 */
export const availableIcons: string[] = [
  "Adjustments",
  "AlertCircle",
  "AlertOctagon",
  "AlertTriangle",
  "Api",
  "ArrowDown",
  "ArrowDownRight",
  "ArrowLeft",
  "ArrowLeftRight",
  "ArrowRight",
  "ArrowUp",
  "ArrowUpRight",
  "ArrowsExchange",
  "ArrowsHorizontal",
  "ArrowsLeftRight",
  "ArrowsRightLeft",
  "ArrowsSort",
  "Atom",
  "Award",
  "BatteryCharging",
  "Bell",
  "Bike",
  "Bolt",
  "BrandAws",
  "BrandAzure",
  "BrandGoogleDrive",
  "BrandSlack",
  "Briefcase",
  "Building",
  "BuildingBank",
  "BuildingCommunity",
  "BuildingSkyscraper",
  "BuildingStore",
  "BuildingWarehouse",
  "Bulb",
  "Bus",
  "Calculator",
  "Calendar",
  "CalendarCheck",
  "CalendarClock",
  "CalendarDot",
  "CalendarEvent",
  "CalendarMinus",
  "CalendarMonth",
  "CalendarRepeat",
  "CalendarStats",
  "CalendarTime",
  "CalendarWeek",
  "Camera",
  "CameraRotate",
  "Car",
  "CarGarage",
  "CarOff",
  "Cash",
  "CashBanknote",
  "ChartBar",
  "ChartLine",
  "ChartPie",
  "Check",
  "Checklist",
  "Checks",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "ChevronsLeft",
  "Circle",
  "CircleCheck",
  "CirclePlus",
  "CircleX",
  "Click",
  "ClipboardCheck",
  "Clock",
  "ClockPlus",
  "Cloud",
  "CloudDownload",
  "CloudFog",
  "CloudRain",
  "CloudSnow",
  "CloudStorm",
  "CloudUpload",
  "Coins",
  "Copy",
  "CreditCard",
  "Crown",
  "CurrencyDollar",
  "CurrentLocation",
  "Dashboard",
  "Database",
  "DeviceMobile",
  "Dots",
  "DotsVertical",
  "Download",
  "Droplet",
  "Edit",
  "Engine",
  "ExternalLink",
  "Eye",
  "EyeOff",
  "File",
  "FileSpreadsheet",
  "FileText",
  "FileUpload",
  "FileX",
  "Files",
  "Filter",
  "FirstAidKit",
  "Flag",
  "Flame",
  "FocusCentered",
  "Folder",
  "FolderOpen",
  "Forms",
  "GasStation",
  "Gauge",
  "GlassFull",
  "Globe",
  "GripHorizontal",
  "Hammer",
  "Hash",
  "Heart",
  "HeartRateMonitor",
  "Help",
  "HelpCircle",
  "History",
  "Home",
  "Hourglass",
  "InfoCircle",
  "Key",
  "Leaf",
  "Link",
  "List",
  "ListCheck",
  "ListDetails",
  "Loader",
  "Lock",
  "Logout",
  "Mail",
  "Map",
  "MapOff",
  "MapPin",
  "MapPin2",
  "MapPinCog",
  "MapPinFilled",
  "MapPinOff",
  "MapPinPlus",
  "Maximize",
  "Menu",
  "Message",
  "Minimize",
  "Minus",
  "Moon",
  "Motorbike",
  "Mountain",
  "Note",
  "Notebook",
  "Notes",
  "Package",
  "Packages",
  "Palette",
  "Paperclip",
  "Parking",
  "ParkingCircle",
  "ParkingOff",
  "Pencil",
  "Percentage",
  "Phone",
  "Photo",
  "PlayerPause",
  "PlayerPlay",
  "Plus",
  "Printer",
  "QuestionMark",
  "Radio",
  "Receipt",
  "Refresh",
  "Repeat",
  "ReportMoney",
  "Road",
  "Rocket",
  "Rotate",
  "RotateClockwise",
  "RotateClockwise2",
  "Route",
  "Search",
  "Selector",
  "Send",
  "Settings",
  "Shield",
  "ShieldCheck",
  "ShieldExclamation",
  "Shirt",
  "ShoppingCart",
  "Signature",
  "Snowflake",
  "SortAscending",
  "SortDescending",
  "SquareCheck",
  "SteeringWheel",
  "Sticker",
  "Sun",
  "Tag",
  "Target",
  "Temperature",
  "ThumbDown",
  "ThumbUp",
  "ToggleLeft",
  "Tool",
  "TransferOut",
  "Trash",
  "TrendingDown",
  "TrendingUp",
  "Truck",
  "Upload",
  "User",
  "UserCheck",
  "UserCircle",
  "UserEdit",
  "UserMinus",
  "UserPlus",
  "UserX",
  "Users",
  "Wallet",
  "Webhook",
  "Wheel",
  "Wifi",
  "Wind",
  "World",
  "X",
  "ZoomIn",
  "ZoomOut"
];
